export const setLocalItem = (key, value) => {
  const jsonString = JSON.stringify(value)
  localStorage.setItem(key, jsonString)
}

export const getLocalItem = (key) => {
  try {
    const value = localStorage.getItem(key)
    return JSON.parse(value)
  } catch {
    return localStorage.getItem(key)
  }

}

export const deleteLocalItem = (key) => {
  localStorage.removeItem(key)
}

export const deleteLocal = () => {
  localStorage.clear()
}